import { render, staticRenderFns } from "./viewStaffInfo.vue?vue&type=template&id=1964ae8c"
import script from "./viewStaffInfo.vue?vue&type=script&lang=js"
export * from "./viewStaffInfo.vue?vue&type=script&lang=js"
import style0 from "./viewStaffInfo.vue?vue&type=style&index=0&id=1964ae8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports